export const FETCH_MYTOPOS_REQUESTED = "FETCH_MYTOPOS_REQUESTED";
export const FETCH_MYTOPOS_SUCCESS = "FETCH_MYTOPOS_SUCCESS";
export const FETCH_MYTOPOS_ERROR = "FETCH_MYTOPOS_ERROR";
export const DELETE_REQUESTED = "DELETE_REQUESTED";
export const DELETE_SUCCESS = "DELETE_SUCCESS";
export const DELETE_ERROR = "DELETE_ERROR";
export const FETCH_TASKS_REQUESTED = "FETCH_TASKS_REQUESTED";
export const FETCH_TASKS_SUCCESS = "FETCH_TASKS_SUCCESS";
export const FETCH_TASKS_ERROR = "FETCH_TASKS_ERROR";
export const CLOSE_TASKS = "CLOSE_TASKS";
export const RESET_TASK_REQUESTED = "RESET_TASK_REQUESTED";
export const RESET_TASK_SUCCESS = "RESET_TASK_SUCCESS";
export const RESET_TASK_ERROR = "RESET_TASK_ERROR";
export const SKIP_TASK_REQUESTED = "SKIP_TASK_REQUESTED";
export const SKIP_TASK_SUCCESS = "SKIP_TASK_SUCCESS";
export const SKIP_TASK_ERROR = "SKIP_TASK_ERROR";
export const PAUSE_TASK_REQUESTED = "PAUSE_TASK_REQUESTED";
export const PAUSE_TASK_SUCCESS = "PAUSE_TASK_SUCCESS";
export const PAUSE_TASK_ERROR = "PAUSE_TASK_ERROR";
export const FETCH_TASK_LOGS_REQUESTED = "FETCH_TASK_LOGS_REQUESTED";
export const FETCH_TASK_LOGS_SUCCESS = "FETCH_TASK_LOGS_SUCCESS";
export const FETCH_TASK_LOGS_ERROR = "FETCH_TASK_LOGS_ERROR";
export const CLOSE_TASK_LOGS = "CLOSE_TASK_LOGS";
export const FETCH_PROPERTY_BAG_REQUESTED = "FETCH_PROPERTY_BAG_REQUESTED";
export const FETCH_PROPERTY_BAG_SUCCESS = "FETCH_PROPERTY_BAG_SUCCESS";
export const FETCH_PROPERTY_BAG_ERROR = "FETCH_PROPERTY_BAG_ERROR";
export const CLOSE_PROPERTY_BAG = "CLOSE_PROPERTY_BAG";
export const UPLOAD_PROPERTY_BAG_REQUESTED = "UPLOAD_PROPERTY_BAG_REQUESTED";
export const UPLOAD_PROPERTY_BAG_SUCCESS = "UPLOAD_PROPERTY_BAG_SUCCESS";
export const UPLOAD_PROPERTY_BAG_ERROR = "UPLOAD_PROPERTY_BAG_ERROR";
export const UPDATE_PROPERTY_FOR_PROPERTY_BAG = "UPDATE_PROPERTY_FOR_PROPERTY_BAG";
export const FETCH_TOPOLOGY_TYPES_REQUESTED = "FETCH_TOPOLOGY_TYPES_REQUESTED";
export const FETCH_TOPOLOGY_TYPES_SUCCESS = "FETCH_TOPOLOGY_TYPES_SUCCESS";
export const FETCH_TOPOLOGY_TYPES_ERROR = "FETCH_TOPOLOGY_TYPES_ERROR";
export const FETCH_BUILD_NUMBERS_ERROR = "FETCH_BUILD_NUMBERS_ERROR";
export const CLOSE_CREATE_TOPOLOGY = "CLOSE_CREATE_TOPOLOGY";
export const CHECKOUT_REQUESTED = "CHECKOUT_REQUESTED";
export const CHECKOUT_SUCCESS = "CHECKOUT_SUCCESS";
export const CHECKOUT_ERROR = "CHECKOUT_ERROR";
export const UPDATE_REPLACEABLE = "UPDATE_REPLACEABLE";
export const DEPLOY_TOPOLOGY_TYPE_SUCCESS = "DEPLOY_TOPOLOGY_TYPE_SUCCESS";
export const DEPLOY_TOPOLOGY_TYPE_ERROR = "DEPLOY_TOPOLOGY_TYPE_ERROR";
export const DEPLOY_TOPOLOGY_TYPE_WITH_QUEUE_REQUESTED = "DEPLOY_TOPOLOGY_TYPE_WITH_QUEUE_REQUESTED";
export const DEPLOY_TOPOLOGY_TYPE_WITH_QUEUE_SUCCESS = "DEPLOY_TOPOLOGY_TYPE_WITH_QUEUE_SUCCESS";
export const DEPLOY_TOPOLOGY_TYPE_WITH_QUEUE_ERROR = "DEPLOY_TOPOLOGY_TYPE_WITH_QUEUE_ERROR";
export const UPLOAD_TEMPLATE_REQUESTED = "UPLOAD_TEMPLATE_REQUESTED";
export const UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_REQUESTED = "UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_REQUESTED";
export const UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_SUCCESS = "UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_SUCCESS";
export const UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_ERROR = "UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_ERROR";
export const RESET_TEMPLATE_FOR_LOOKUP_FILE = "RESET_TEMPLATE_FOR_LOOKUP_FILE";
export const UPLOAD_TEMPLATE_ERROR = "UPLOAD_TEMPLATE_ERROR";
export const UPLOAD_LOOKUPFILE_REQUESTED = "UPLOAD_LOOKUPFILE_REQUESTED";
export const UPLOAD_LOOKUPFILE_ERROR = "UPLOAD_LOOKUPFILE_ERROR";
export const CLOSE_CREATE_PRIVATE_TOPOLOGY = "CLOSE_CREATE_PRIVATE_TOPOLOGY";
export const CLOSE_CREATE_LOOKUP_TOPOLOGY = "CLOSE_CREATE_LOOKUP_TOPOLOGY";
export const DEPLOY_PRIVATE_TEMPLATE_REQUESTED = "DEPLOY_PRIVATE_TEMPLATE_REQUESTED";
export const DEPLOY_PRIVATE_TEMPLATE_SUCCESS = "DEPLOY_PRIVATE_TEMPLATE_SUCCESS";
export const DEPLOY_PRIVATE_TEMPLATE_ERROR = "DEPLOY_PRIVATE_TEMPLATE_ERROR";
export const DEPLOY_LOOKUP_TOPOLOGY_TYPE_REQUESTED = "DEPLOY_LOOKUP_TOPOLOGY_TYPE_REQUESTED";
export const DEPLOY_LOOKUP_TOPOLOGY_TYPE_SUCCESS = "DEPLOY_LOOKUP_TOPOLOGY_TYPE_SUCCESS";
export const DEPLOY_LOOKUP_TOPOLOGY_TYPE_ERROR = "DEPLOY_LOOKUP_TOPOLOGY_TYPE_ERROR";
export const RENAME_TOPOLOGY_REQUESTED = "RENAME_TOPOLOGY_REQUESTED";
export const RENAME_TOPOLOGY_SUCCESS = "RENAME_TOPOLOGY_SUCCESS";
export const RENAME_TOPOLOGY_ERROR = "RENAME_TOPOLOGY_ERROR";
export const TRANSFER_OWNERSHIP_REQUESTED = "TRANSFER_OWNERSHIP_REQUESTED";
export const TRANSFER_OWNERSHIP_SUCCESS = "TRANSFER_OWNERSHIP_SUCCESS";
export const TRANSFER_OWNERSHIP_ERROR = "TRANSFER_OWNERSHIP_ERROR";
export const FETCH_CLOUD_TYPES_DEFAULT_CLASSIC_REQUESTED = "FETCH_CLOUD_TYPES_DEFAULT_CLASSIC_REQUESTED";
export const FETCH_CLOUD_TYPES_DEFAULT_CLASSIC_SUCCESS = "FETCH_CLOUD_TYPES_DEFAULT_CLASSIC_SUCCESS";
export const FETCH_CLOUD_TYPES_DEFAULT_CLASSIC_ERROR = "FETCH_CLOUD_TYPES_DEFAULT_CLASSIC_ERROR";
export const FETCH_DEBUGGER_PORT_REQUESTED = "FETCH_DEBUGGER_PORT_REQUESTED";
export const FETCH_DEBUGGER_PORT_SUCCESS = "FETCH_DEBUGGER_PORT_SUCCESS";
export const FETCH_DEBUGGER_PORT_ERROR = "FETCH_DEBUGGER_PORT_ERROR";
export const FETCH_MYQUEUEREQUESTS_REQUESTED = "FETCH_MYQUEUEREQUESTS_REQUESTED";
export const FETCH_MYQUEUEREQUESTS_SUCCESS = "FETCH_MYQUEUEREQUESTS_SUCCESS";
export const FETCH_MYQUEUEREQUESTS_ERROR = "FETCH_MYQUEUEREQUESTS_ERROR";
export const CANCEL_QUEUE_REQUEST_REQUESTED = "CANCEL_QUEUE_REQUEST_REQUESTED";
export const CANCEL_QUEUE_REQUEST_SUCCESS = "CANCEL_QUEUE_REQUEST_SUCCESS";
export const CANCEL_QUEUE_REQUEST_ERROR = "CANCEL_QUEUE_REQUEST_ERROR";
export const TOGGLE_QUEUE_REQUEST = "TOGGLE_QUEUE_REQUEST";
export const CLEAR_SELECTED_QUEUE_REQUESTS = "CLEAR_SELECTED_QUEUE_REQUESTS";
export const FETCH_DUPLICATE_THRESHOLD_TOPOLOGY_NAMES_REQUESTED =
  "FETCH_DUPLICATE_THRESHOLD_TOPOLOGY_NAMES_SUCCESS_REQUESTED";
export const FETCH_DUPLICATE_THRESHOLD_TOPOLOGY_NAMES_SUCCESS = "FETCH_DUPLICATE_THRESHOLD_TOPOLOGY_NAMES_SUCCESS";
export const FETCH_DUPLICATE_THRESHOLD_TOPOLOGY_NAMES_ERROR = "FETCH_DUPLICATE_THRESHOLD_TOPOLOGY_NAMES_ERROR";
export const GET_USER_REGION_REQUESTED = "GET_USER_REGION_REQUESTED";
export const GET_USER_REGION_SUCCESS = "GET_USER_REGION_SUCCESS";
export const GET_USER_REGION_ERROR = "GET_USER_REGION_ERROR";
